import React from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { gritComponentStyles } from './gritComponentStyles';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import DeleteIcon from '@mui/icons-material/Delete';

interface ClaimTransformationListProps {
  list: string[];
  onEditHandler: (val: string) => void;
  onDeleteHandler: (val: string) => void;
}

function ClaimTransformationList({ list, onEditHandler, onDeleteHandler }: ClaimTransformationListProps) {
  const classes = gritComponentStyles();
  return (
    <>
      {list.map((el: string) => {
        return (
          <div key={el} className={cn(classes.policyEntry, classes.flexRow)}>
            <span className={classes.label}>{el} </span>
            <ModeEditOutlineSharpIcon onClick={() => onEditHandler(el)} className={classes.icon} color="primary" />
            <DeleteIcon
              onClick={() => {
                window.confirm('Are you sure you want to delete ' + el + '? This cannot be undone.') &&
                  onDeleteHandler(el);
              }}
              className={classes.icon}
              color="error"
            />
          </div>
        );
      })}
    </>
  );
}

// export default withAITracking(reactPlugin, ClaimTransformationList);
export default ClaimTransformationList;
